import { appbarHeight, appbarHeightMobile } from "themes/constants/sizes"
import { masterBreakPoint } from "themes/default/breakpoints"
import { theme } from "themes/default/theme"
import { styles as controllerStyles } from "components/UI/AudioPlayer/themes/bluePlayer.styles"

export const styles = {
  absolute: {
    position: "absolute",
    top: `${appbarHeight + 5}px`,
    left: 10,
    [masterBreakPoint]: {
      top: `${appbarHeightMobile}px`,
    },
  },
  soundButton: {
    backgroundColor: theme.palette.primary.main,
    zIndex: 10,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
    "&:disabled": {
      backgroundColor: theme.palette.primary.main,
      cursor: "not-allowed",
      pointerEvents: "all",
    },
  },
  transparent: {
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    color: theme.palette.common.white,
    fontSize: {
      xs: 24,
      md: 30,
    },
    [masterBreakPoint]: {
      fontSize: 24,
    },
  },
  controllers: controllerStyles.controllers,
}
